import { defineComponent } from '@vue/composition-api';
import { Btn, BtnTheme } from '@/components/Button';
export default defineComponent({
    components: { Btn },
    setup() {
        return { BtnTheme };
    },
});
